exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#careers[data-v-91017836]{padding-bottom:50px;min-height:calc(100vh - 119px);background-color:hsla(0,0%,100%,.5)}#careers .main[data-v-91017836]{height:calc(100vh - 50px)}#careers label[data-v-91017836]{margin-bottom:0;font-size:14px;color:#777}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91017836","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Careers.vue
// module id = 55
// module chunks = 0